import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    formationsFetchData,
    playersFetchData,
    setManageTeamMode,
    postSubstituteTeam,
    postCaptain,
    setPopupState,
    triggerHandleFixturePopup,
    triggerMixFetchData,
    triggerLiveScoreFetchData,
    setTeamLockToastCookie,
    fetchPlayerRecomendation,
    setPlayerRecomendationFirstTimeFalse,
    showHidePlayerRecomendationPopUp,
    showHidePlayerRecomendationPopUpMob
} from './../../actions/FormationActions';
import {
    getFixtures,
    getUserPlayedGameDays,
    getUserTeamOfMatchDay,
    createManageTeamSkeleton,
    getUserSpecificFixtures,
    updateCurrentActiveFixture,
    resetTransfers,
    resetTeamData,
} from './../../actions/ManageTeamActions';
import {
    resetAllFilters,
} from './../../actions/FilterActions';
import { setTotalScore } from './../../actions/AppActions';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import Fixture from './../manage-team/Fixture';
import ManageTeamStatus from './../manage-team/Manage-Team-Status';
import MainPitchManageTeam from './../manage-team/MainPitch-ManageTeam';
import TopSectionHeader from './../manage-team/Top-Section-Header';
import MatchdayStatus from './../manage-team/Matchday-Status';
import LockScreen from './../manage-team/Lock-Screen';
import FormationPopup from './../onboarding/FormationPopup';
import Modal from './../Modal';
import PlayerCard from './../playerCard';
import ErrorModal from './../GenericMessage';
import GeneralPopUp from './../GeneralPopUp';
import BoosterPopup from './../BoosterPopup';
import apiError from './../../constants/api-error';
import UpcomingFixturesPopup from './../matches/upcomingFixturesPopup';
import config from './../../config';
import common from './../../common';
import {
    getState,
    getInTeamArray,
    getOutTeamArray,
    getSubstitutionStatus,
    getSubstitutionsApiData,
    getFixtureStatus,
    getLivePlayersData,
} from "../../helper";
import {
    isBoosterTaken,
} from "../../helper-booster";
import {
    isLockToastKeyExists,
    getBoosterStatus,
    getWildCardStatus
} from "../../helper-common";
import AutoSubsPlayers from './Auto-Substitution-Players';
import Matches from "../matches";
import routeObject from '../../constants/new-pageTrackEvents'

class ManageTeam extends Component {
    constructor(props) {
        super(props);
        this.timeout = null;
        this.timer = null;
        this.state = { showLockScreen: false, newSelectedCaptain: null };
    }

    timeout_mix = 0;
    timeout_local = 0;
    timeout_live = 0;
    closeLockScreen = () => {
        this.setState({ showLockScreen: false });
        common.updateBusters('/bust-after-status-change');
        this.props.setManageTeamMode(config.modes["view-manage-team"]);
        this.init();
    };

    componentWillMount() {
        this.props.resetTeamData();
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.fixtures.length !== this.props.fixtures.length) || nextProps.userPlayedMatchDays.length !== this.props.userPlayedMatchDays.length) {
            if (nextProps.fixtures.length && nextProps.userPlayedMatchDays.length) {
                const { matchDayID } = this.props.match.params;
                this.props.getUserSpecificFixtures(matchDayID);
            }
        }
        if ((nextProps.userSpecificFixtures.length !== this.props.userSpecificFixtures.length) || nextProps.currentActiveFixture !== this.props.currentActiveFixture) {
            this.clearAllTimeout();
            common.showLoader();
            if (nextProps.userSpecificFixtures.length === 0) return;
            const { userSpecificFixtures, currentActiveFixture } = nextProps;
            const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
            if (currentFixture.status === config.fixtureStatus.isLock) {
                this.callLiveAPI();
            } else if (currentFixture.status !== config.fixtureStatus.isFinished) {
                this.setTimeOutForTeamLockToast(currentFixture.Deadline, nextProps.constraints.OffSet, 'lockingToastForMD_' + (currentFixture.MatchDay), nextProps.trans.teamLockToast);
                this.hitMixAPi();
            }
            const { GDID, PhID } = currentFixture;
            const GUID = common.getGUID();
            const getUsersTeamPromise = this.props.getUserTeamOfMatchDay(GUID, GDID, PhID);
            const formationPromise = this.props.fetchFormations(GDID);
            const playersPromise = this.props.fetchPlayers(GDID);
            Promise.all([getUsersTeamPromise, formationPromise, playersPromise]).then(() => {
                this.props.setTotalScore(this.props.getTeam.OVPoints);
                this.props.createManageTeamSkeleton();
                if (this.props.callPlayerRecomendation) {
                    //call platyer recomendation player
                    this.props.fetchPlayerRecomendation()
                }
                common.hideLoader();
            }).catch(reason => {
            });
        }
    }

    setTimeOutForTeamLockToast(Deadline, OffSet, gdKey, message) {
        let self = this;
        common.getDiffWithCurrentTimeInMinutes(Deadline, OffSet, diffInMins => {
            if (self.timer) {
                clearTimeout(self.timer);
            }
            if (diffInMins > 0) {
                if (!isLockToastKeyExists(gdKey)) {
                    self.timer = setTimeout(() => {
                        if (diffInMins <= 5) {
                            self.props.setTeamLockToastCookie(gdKey);
                            self.setPopupStateObj({
                                showPopup: true,
                                isToast: true,
                                message: message,
                                wrapperClasses: 'si-warning-toast si-warning-popup',
                                iconClass: 'icon-ucl-warning-icon',
                                resetToast: self.resetToast
                            });
                        }
                        self.setTimeOutForTeamLockToast(Deadline, OffSet, gdKey);
                    }, 1000 * config.TEAM_LOCK_TOAST_CHECK_INTERVAL);
                }
            }
        });
    }

    startInterval = (Deadline, OffSet, MixApiFixtureStatus) => {
        if (MixApiFixtureStatus !== config.fixtureStatus.isLock) {
            common.getDiffWithCurrentTimeInMinutes(Deadline, OffSet, (diffInMins) => {
                if (diffInMins > config.TIME_DIFF_TO_CONSIDER) {
                    if (diffInMins < config.MIXED_API_INTERVAL_START_TIME) {
                        this.timeout_mix = setTimeout(this.hitMixAPi, 1000 * config.MIXED_API_INTERVAL_DURATION);
                    } else {
                        this.timeout_local = setTimeout(() => {
                            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
                        }, 1000 * config.MIXED_API_BEFORE_INTERVAL_DURATION);
                    }
                }
            });
        }
    };
    hitMixAPi = () => {
        let self = this;
        this.props.triggerMixFetchData().then(() => {
            const mixedResponse = this.props.mixResponse;
            const { OffSet } = this.props.constraints;
            let { Deadline, Fixture } = mixedResponse;
            const MixApiFixtureStatus = getFixtureStatus(Fixture || {});
            if (Fixture !== null) {
                const { userSpecificFixtures, currentActiveFixture, manageTeamMode } = this.props;
                const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
                const gamedayId = currentFixture['GDID'];
                if (+gamedayId === +Fixture['GDID']) {
                    const userFixtureStatus = currentFixture.status;
                    if (userFixtureStatus !== MixApiFixtureStatus) {
                        if (MixApiFixtureStatus === config.fixtureStatus.isLock && (manageTeamMode === config.modes.transfer || manageTeamMode === config.modes.substitution)) {
                            return this.setState({ showLockScreen: true });
                        } else {
                            common.updateBusters('/bust-after-status-change');
                            return self.init();
                        }
                    }
                }
            }
            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
        });
    };
    callLiveAPI = () => {
        this.props.triggerLiveScoreFetchData().then(() => {
            this.timeout_live = setTimeout(() => {
                this.hitMixAPi();
                this.callLiveAPI();
            }, 1000 * config.MIXED_API_INTERVAL_DURATION);
        });
    };
    clearAllTimeout = () => {
        clearTimeout(this.timeout_mix);
        clearTimeout(this.timeout_local);
        clearTimeout(this.timeout_live);
    };
    getTeam = () => {
        this.clearAllTimeout();
        let { userSpecificFixtures, currentActiveFixture } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        const { GDID, PhID } = currentFixture;
        const GUID = common.getGUID();
        const getUsersTeamPromise = this.props.getUserTeamOfMatchDay(GUID, GDID, PhID);
        getUsersTeamPromise.then(() => {
            this.props.setTotalScore(this.props.getTeam.OVPoints);
            this.props.createManageTeamSkeleton();
            common.hideLoader();
        }).catch(reason => {
            common.hideLoader();
        });
    };

    componentDidMount() {
        this.init();
    }

    init = () => {
        this.clearAllTimeout();
        common.showLoader();
        const GUID = common.getGUID();
        this.props.getFixtures();
        this.props.getUserPlayedGameDays(GUID);
    };

    componentWillUnmount() {
        this.clearAllTimeout();
        this.props.triggerHandleFixturePopup(false);
        clearTimeout(this.timeout);
    }

    handleNext = (btnType) => {

        let { currentActiveFixture } = this.props;
        const { userSpecificFixtures } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        let getViewState = null;
        if (currentFixture) {
            getViewState = getState(currentFixture);
        }


        if (this.props.manageTeamMode === config.modes["view-manage-team"]) {
            if (btnType === "transfer") {
                this.props.resetAllFilters();
                // common.pageViewTracking("", routeObject["myTeam"]);
                this.props.setManageTeamMode(config.modes["transfer"]);
            } else if (btnType === "substitute") {
                this.props.setManageTeamMode(config.modes["substitution"]);
            } else if (btnType === "ChangeCaptainPopup") {
              if (getViewState == config.possibleActions.subsAndTransfer) {
                this.setPopupStateObj({
                  showPopup: false,
                  message: ''
                })
                this.saveCaptain();
              } else {
                this.setPopupStateObj({
                  showPopup: true,
                  title:
                    this.props.trans['changeCaptainTitle'] || 'Change Captain?',
                  message:
                    getViewState == config.possibleActions.substitution
                      ? this.props.trans['changeCaptainDesc'] ||
                        'Changing the captain will reset the bonus points obtained by your original captain.'
                      : this.props.trans['captainChgOnsubt'] ||
                        'Are you sure you want to change your captain?',
                  wrapperClasses: 'si-popup-warning',
                  secondaryBtnText:
                    this.props.trans['changeCaptainBtn'] || 'Change Captain',
                  primaryBtnText: this.props.trans['cancel'] || 'Cancel',
                  secondaryBtnHandler: this.saveCaptain,
                  primaryBtnHandler: this.resetToast,
                  iconClass: 'icon-ucl-warning-icon'
                });
              }
            }
        } else if (this.props.manageTeamMode === config.modes["transfer"]) {
            if (btnType === "cancel") {
                const { playerCount, teamData, manageTeamRawData } = this.props;
                const transferOut = getOutTeamArray(teamData, manageTeamRawData);
                let showDiscardChangesPopup = (transferOut.length > 0) || (playerCount < config.MAX_PLAYERS_PER_TEAM);
                let boosterApplied = false;
                let currentFixture = { "GDID": 0 };
                if (this.props.userSpecificFixtures && this.props.userSpecificFixtures.length) {
                    currentFixture = this.props.userSpecificFixtures[(this.props.currentActiveFixture || 0)];
                }

                const {
                    GDID
                } = currentFixture;

                const boosterStatus = getBoosterStatus(this.props.teamData, GDID || 0);
                const wildCardStatus = getWildCardStatus(this.props.teamData, GDID || 0);
                if (boosterStatus == config.limitlessBoosterStatus["usedInCurrentTemp"] || wildCardStatus == config.wildCardStatus["usedInCurrentTemp"]) {
                    boosterApplied = true;
                }

                if (showDiscardChangesPopup || boosterApplied) {
                    this.setPopupStateObj({
                        showPopup: true,
                        message: this.props.trans["changesWarning"],
                        wrapperClasses: 'si-popup-warning',
                        secondaryBtnText: this.props.trans["discard"],
                        primaryBtnText: this.props.trans["keep"],
                        secondaryBtnHandler: this.confirmCancel,
                        primaryBtnHandler: this.resetToast,
                        iconClass: 'icon-ucl-warning-icon'
                    });
                } else {
                    common.pageViewTracking("", routeObject["myTeam"]);

                    this.props.resetTransfers();
                    // common.customTracking('Transfers - Discard');
                    this.props.setManageTeamMode(config.modes["view-manage-team"]);
                }
            } else if (btnType === "confirmCancel") {
                common.pageViewTracking("", routeObject["myTeam"]);
                this.props.resetTransfers();
                // common.customTracking('Transfers - Discard Confirm');
                this.resetToast();
                this.props.setManageTeamMode(config.modes["view-manage-team"]);
            } else if (btnType === "next") {
                this.clearAllTimeout();
                this.props.triggerHandleFixturePopup(false);
                clearTimeout(this.timeout);
                // common.customTracking('Transfers - Next');
                this.props.setManageTeamMode(config.modes["transfer-summary"]);
                return this.props.history.push('/transfer-summary');
            }
        } else if (this.props.manageTeamMode === config.modes["transfer-summary"]) {
            this.props.setManageTeamMode(config.modes["view-manage-team"]);
            return this.props.history.push('/manage-team');
        } else if (this.props.manageTeamMode === config.modes["substitution"]) {
            if (btnType === "cancel") {
                common.pageViewTracking("", routeObject["myTeam"]);
                const { teamData } = this.props;
                const playersSubstituted = getSubstitutionsApiData(teamData);
                if (playersSubstituted && playersSubstituted.SubPlayerBenchPosition.length > 0 && playersSubstituted.SubPlayerId.length > 0) {
                    this.setPopupStateObj({
                        showPopup: true,
                        message: this.props.trans["changesWarning"],
                        wrapperClasses: 'si-popup-warning',
                        secondaryBtnText: this.props.trans["discard"],
                        primaryBtnText: this.props.trans["keep"],
                        secondaryBtnHandler: this.confirmCancel,
                        primaryBtnHandler: this.resetToast,
                        iconClass: 'icon-ucl-warning-icon'
                    });
                } else {
                    this.props.resetTransfers();
                    // common.customTracking('Substitute - Discard');
                    this.props.setManageTeamMode(config.modes["view-manage-team"]);
                }
            } else if (btnType === "confirmCancel") {
                // common.pageViewTracking("", routeObject["myTeam"]);
                this.props.resetTransfers();
                // common.customTracking('Substitute - Discard Confirm');
                this.resetToast();
                this.props.setManageTeamMode(config.modes["view-manage-team"]);
            } else {
                common.pageViewTracking("", routeObject["myTeam"]);
                common.customTracking('Substitute - Confirm', '/uclfantasy/my-team/substitutions/');
                this.confirmSubstitution();
            }
        }
    };
    confirmSubstitution = () => {
        /* Substitutions post api data starts */

        const { userSpecificFixtures, teamData } = this.props;
        if (userSpecificFixtures.length === 0) return null;
        const playersSubstituted = getSubstitutionsApiData(teamData);
        if (playersSubstituted.showConfirmation) {
            this.setPopupStateObj({
                showPopup: true,
                title: this.props.subsHeading,
                iconClass: 'icon-ucl-warning-icon',
                message: this.props.trans["subsPointLost"] || "You're about to sub off a player that played yesterday. Once you confirm, you’ll lose any points they scored and you won’t be able to undo the sub.",
                wrapperClasses: 'si-popup-warning',
                secondaryBtnText: this.props.trans["subsCancel"] || "No, cancel",
                primaryBtnText: this.props.trans["subsConfirm"] || "Yes, confirm",
                secondaryBtnHandler: this.resetToast,
                primaryBtnHandler: () => {
                    this.substitute(playersSubstituted);
                }
            });
        }
        else {
            this.substitute(playersSubstituted);
        }

    };

    substitute = (playersSubstituted) => {
        const { userSpecificFixtures, currentActiveFixture, teamData, defaultFormation } = this.props;
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        const GUID = common.getGUID();

        common.showLoader();
        const OBJ = {};
        OBJ.OptType = 1;
        OBJ.Platform = config.PLATFORM_ID;
        OBJ.GamedayId = selectedMatchDay['GDID'];
        OBJ.PhaseId = selectedMatchDay['PhID'];
        OBJ.CaptainId = teamData.captainID;
        OBJ.IsWildcard = teamData.IsWildCardTaken;
        OBJ.InPlayerId = [];
        OBJ.InPlayerBenchPosition = [];
        OBJ.OutPlayerId = [];
        OBJ.OutPlayerBenchPosition = [];
        OBJ.SubPlayerId = playersSubstituted.SubPlayerId;
        OBJ.SubPlayerBenchPosition = playersSubstituted.SubPlayerBenchPosition;
        OBJ.GDCompId = 9;
        OBJ.MDCompId = defaultFormation.CompId;
        OBJ.ISMCPR = 0;
        OBJ.IsNewsletter = 0;
        OBJ.LangCode = config.CURRENT_LANGUAGE;
        OBJ.BadgeId = 0;
        OBJ.FavTeamId = 0;
        OBJ.TeamName = "";
        /* Substitutions post api data ends */
        this.props.postSubstituteTeam(GUID, OBJ)
            .then(() => {
                const { response } = this.props.savedSubstitutionData;
                const retVal = response.Meta['RetVal'];
                const messageTrans = apiError.transfers[retVal];
                const message = this.props.trans[messageTrans];
                if (response.Meta['Success'] && retVal === 1) {
                    this.props.setManageTeamMode(config.modes["view-manage-team"]);
                    this.setPopupStateObj({
                        showPopup: true,
                        isToast: true,
                        message: message,
                        wrapperClasses: 'si-warning-toast si-success-popup',
                        iconClass: 'icon-ucl-tick',
                        resetToast: this.resetToast
                    });
                    this.getTeam();
                } else {
                    common.hideLoader();
                    this.setPopupStateObj({
                        showPopup: true,
                        isToast: true,
                        message: message,
                        wrapperClasses: 'si-warning-toast si-error-popup',
                        iconClass: 'icon-ucl-warning-icon',
                        resetToast: this.resetToast
                    });
                    if (retVal === 1001) {
                        common.updateBusters('/bust-after-status-change');
                        this.props.setManageTeamMode(config.modes["view-manage-team"]);
                        this.init();
                    }
                }
            });
    }

    captainChangePopup = (playerId) => {
        // this.setState({ newSelectedCaptain: playerId });
        // this.handleNext("ChangeCaptainPopup");
        
        this.setState({ newSelectedCaptain: playerId }, () => {
          this.handleNext("ChangeCaptainPopup");
          //finished
      });
    };
    saveCaptain = () => {
        /* Captain post api data starts */
        common.customTracking('Captain - Player Card', '/uclfantasy/my-team/manage/');
        if (!this.state.newSelectedCaptain) {
            return false;
        }
        common.showLoader();
        const { userSpecificFixtures, currentActiveFixture, teamData, defaultFormation } = this.props;
        if (userSpecificFixtures.length === 0) return null;
        const GUID = common.getGUID();
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        const OBJ = {};
        OBJ.OptType = 1;
        OBJ.Platform = config.PLATFORM_ID;
        OBJ.GamedayId = selectedMatchDay['GDID'];
        OBJ.PhaseId = selectedMatchDay['PhID'];
        OBJ.CaptainId = this.state.newSelectedCaptain;
        OBJ.IsWildcard = teamData.IsWildCardTaken;
        OBJ.InPlayerId = [];
        OBJ.InPlayerBenchPosition = [];
        OBJ.OutPlayerId = [];
        OBJ.OutPlayerBenchPosition = [];
        OBJ.SubPlayerId = [];
        OBJ.SubPlayerBenchPosition = [];
        OBJ.GDCompId = 9;
        OBJ.MDCompId = defaultFormation.CompId;
        OBJ.ISMCPR = 0;
        OBJ.IsNewsletter = 0;
        OBJ.LangCode = config.CURRENT_LANGUAGE;
        OBJ.BadgeId = 0;
        OBJ.FavTeamId = 0;
        OBJ.TeamName = "";
        /* Captain post api data ends */
        this.props.postCaptain(GUID, OBJ)
            .then(() => {
                this.setState({ newSelectedCaptain: null });
                const { response } = this.props.savedCaptainData;
                const retVal = response.Meta['RetVal'];
                const messageTrans = apiError.saveCaptain[retVal];
                const message = this.props.trans[messageTrans];
                if (response.Meta['Success'] && retVal === 1) {
                    this.setPopupStateObj({
                        showPopup: true,
                        isToast: true,
                        message: message,
                        wrapperClasses: 'si-warning-toast si-success-popup',
                        iconClass: 'icon-ucl-tick',
                        resetToast: this.resetToast
                    });
                    this.getTeam();
                } else {
                    common.hideLoader();
                    this.setPopupStateObj({
                        showPopup: true,
                        isToast: true,
                        message: message,
                        wrapperClasses: 'si-warning-toast si-error-popup',
                        iconClass: 'icon-ucl-warning-icon',
                        resetToast: this.resetToast
                    });
                    if (retVal === 1001) {
                        common.updateBusters('/bust-after-status-change');
                        this.init();
                    }
                }
            });
    };
    resetToast = () => {
        let bodyElem = document.body;
        bodyElem.classList.remove('bodyNoScroll');
        this.props.setPopupState({ showPopup: false, message: '' });
    };
    confirmCancel = () => {
        this.handleNext("confirmCancel");
    };
    setPopupStateObj = (obj) => {
        let bodyElem = document.body;
        bodyElem.classList.add('bodyNoScroll');
        this.props.setPopupState(obj);
    };

    render() {
        let { currentActiveFixture } = this.props;
        const { trans, location, manageTeamMode, liveScore, teamData, manageTeamRawData, userSpecificFixtures, mobileFilterOpen, mobilePlayerListingOpen, budget, playerCount, commonError, popupState, boosterPopupState, isPlayerCardVisible, isFixturePopupVisible, teamError } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        let getViewState = null;
        if (currentFixture) {
            getViewState = getState(currentFixture);
        }
        const liveData = getLivePlayersData(teamData, liveScore);
        const { substitutionInitiated } = teamData;
        let showOverlay = mobileFilterOpen;
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-manage-team': true,
            'si-no-anim': true,
            'si-filter-slideIn': mobilePlayerListingOpen,
            'si-slide-up': mobileFilterOpen,
            'si-centered-bg': manageTeamMode !== config.modes["transfer"],
        });
        const containerClass = common.makeClasses({
            'si-container': true,
            'si-substitution-wrap': manageTeamMode === config.modes["view-manage-team"],
            'si-subs-mode': manageTeamMode === config.modes["substitution"],
            'si-transfers-wrap': manageTeamMode === config.modes["transfer"],
        });
        let isDisabled = (playerCount < config.MAX_PLAYERS_PER_TEAM) || (budget < 0);
        let hideAutocomplete = false;
        if (manageTeamMode === config.modes["transfer"]) {
            const transferedIn = getInTeamArray(teamData, manageTeamRawData);
            const isLimitlessSelected = isBoosterTaken('IsBoosterOneTaken', teamData, userSpecificFixtures, currentActiveFixture);
            const budgetRestriction = isLimitlessSelected ? false : (budget < 0);
            hideAutocomplete = isLimitlessSelected;
            isDisabled = (transferedIn.length <= 0) || (budgetRestriction) || (playerCount < config.MAX_PLAYERS_PER_TEAM);
        } else if (manageTeamMode === config.modes["substitution"]) {
            isDisabled = true;
            let subStatus = getSubstitutionStatus(manageTeamRawData, teamData);
            let isSubstituted = subStatus.substituted;
            if (!substitutionInitiated && isSubstituted) {
                isDisabled = false;
            }
        }
        let genericMessage = null;
        switch (commonError) {
            case 'autoFillError': {
                genericMessage = trans['autoFillError'];
                break;
            }
            default: {
                genericMessage = null;
            }
        }
        const { showPopup, isToast, message, title, wrapperClasses, secondaryBtnText, primaryBtnText, secondaryBtnHandler, primaryBtnHandler, iconClass, resetToast } = popupState;
        if (!showPopup) {
            let bodyElem = document.body;
            bodyElem.classList.remove('bodyNoScroll');
        }
        const popupProps = {
            wrapperClass: wrapperClasses,
            showPopup,
            isToast,
            message,
            title,
            secondaryBtnText,
            primaryBtnText,
            secondaryBtnHandler,
            primaryBtnHandler,
            iconClass,
            resetToast,
        };
        // let toShowPlayerList = (getStep(location.pathname) === 0 && (manageTeamMode === config.modes["transfer"]) || manageTeamMode === config.modes["view-manage-team"]);
        let toShowPlayerList = (getStep(location.pathname) === 0) && (manageTeamMode === config.modes["transfer"]);
        //addin the avove or condition  to openn player listing on view summary too
        let showAutoSubsPlayers = (getViewState === config.possibleActions["viewpoint"] && teamData.IsAutoPlay === "1");
        return (
            <React.Fragment>
                <div className={ wrapperClass }>
                    <div className={ containerClass }>
                        <div className={ "si-top-section " + (manageTeamMode === config.modes["transfer"] ? "si-mob" : "") + ((manageTeamMode === config.modes["substitution"] && common.isMobile()) ? " si-custom" : "") }>
                            <TopSectionHeader getTeam={ this.getTeam.bind(this) }
                                handleNext={ this.handleNext.bind(this) } { ...{ isDisabled } }
                                pathStep={ getStep(location.pathname) }
                                viewState={ getViewState } />
                            { manageTeamMode === config.modes["view-manage-team"] ?
                                <Fixture isFixtureDisabled={ getViewState === config.possibleActions["live"] } /> : null }
                            { manageTeamMode === config.modes["transfer"] ?
                                <ManageTeamStatus
                                    handleNext={ this.handleNext.bind(this) } { ...{ isDisabled } } { ...{ hideAutocomplete } } /> : null }
                            { manageTeamMode === config.modes["view-manage-team"] ?
                                <MatchdayStatus livePoints={ liveData.totalLivePoints } pathStep={ getStep(location.pathname) }
                                    viewState={ getViewState } /> : null }
                            { manageTeamMode === config.modes["substitution"] && common.isMobile() ?
                                <div className="si-top-bar si-flexBox"> <div className="si-back-btn si-cols" onClick={ () => { this.handleNext("cancel") } }>
                                    <i className="icon-ucl-back_arrow" />
                                </div>
                                </div>
                                : null }


                        </div>
                        <MainPitchManageTeam toShowList={ toShowPlayerList } handleNext={ this.handleNext.bind(this) }
                            getTeam={ this.getTeam.bind(this) } location={ location } manageTeamMode={ manageTeamMode }
                            captainChangePopup={ this.captainChangePopup.bind(this) } { ...{ isDisabled } }
                            viewState={ getViewState } liveScoringData={ liveData } showPlayerRecomendationPopUp={ this.props.showPlayerRecomendationPopUp } showHidePlayerRecomendationPopUp={ this.props.showHidePlayerRecomendationPopUp } setPlayerRecomendationFirstTimeFalse={ this.props.setPlayerRecomendationFirstTimeFalse } showPlayerrecomendationPopupMobile={ this.props.showPlayerrecomendationPopupMobile } showHidePlayerRecomendationPopUpMob={ this.props.showHidePlayerRecomendationPopUpMob } />
                        { this.state.showLockScreen ?
                            <LockScreen closeLockScreen={ this.closeLockScreen } teamLockTitle={ trans.teamLocked }
                                teamLockDesc={ manageTeamMode === config.modes["substitution"] ? trans.teamLockedSubs : trans.teamLockedtransfer } /> : null }
                        { showAutoSubsPlayers ? <AutoSubsPlayers /> : null }
                        <FormationPopup sendToSubs={ (manageTeamMode === config.modes["view-manage-team"]) }
                            handleNext={ this.handleNext.bind(this) } />
                        { isPlayerCardVisible && !this.props.overview ? <PlayerCard captainChangePopup={ this.captainChangePopup.bind(this) } /> : null }
                        { isFixturePopupVisible ? <UpcomingFixturesPopup /> : null }
                        <Modal error={ teamError } showOverlay={ showOverlay } />
                        <Modal error={ teamError } showOverlay={ showOverlay } />
                        <ErrorModal error={ genericMessage } icon={ "icon-ucl-euro" } />
                        <GeneralPopUp { ...popupProps } />
                        { boosterPopupState.showBoosterPopup ? <BoosterPopup { ...boosterPopupState } /> : null }
                    </div>
                </div>
                {
                    (!config.isMobile)
                        ?
                        <Matches { ...this.props } />
                        :
                        null
                }
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getFixtures: (GamedayId) => dispatch(getFixtures(GamedayId)),
        getUserPlayedGameDays: (guid) => dispatch(getUserPlayedGameDays(guid)),
        getUserTeamOfMatchDay: (guid, gamedayId, phaseId) => dispatch(getUserTeamOfMatchDay(guid, gamedayId, phaseId)),
        fetchFormations: (GamedayId) => dispatch(formationsFetchData(GamedayId)),
        fetchPlayers: (GamedayId) => dispatch(playersFetchData(GamedayId)),
        createManageTeamSkeleton: (constraints) => dispatch(createManageTeamSkeleton(constraints)),
        getUserSpecificFixtures: (matchDayID) => dispatch(getUserSpecificFixtures(matchDayID)),
        updateCurrentActiveFixture: (index) => dispatch(updateCurrentActiveFixture(index)),
        setManageTeamMode: (mode) => dispatch(setManageTeamMode(mode)),
        resetTransfers: () => dispatch(resetTransfers()),
        resetTeamData: () => dispatch(resetTeamData()),
        getInTeamArray: (teamData, oldTeamData) => dispatch(getInTeamArray(teamData, oldTeamData)),
        getOutTeamArray: (teamData, oldTeamData) => dispatch(getOutTeamArray(teamData, oldTeamData)),
        postSubstituteTeam: (GUID, obj) => dispatch(postSubstituteTeam(GUID, obj)),
        postCaptain: (GUID, obj) => dispatch(postCaptain(GUID, obj)),
        setPopupState: (obj) => dispatch(setPopupState(obj)),
        resetAllFilters: () => dispatch(resetAllFilters()),
        triggerHandleFixturePopup: (isFixturePopupVisible) => dispatch(triggerHandleFixturePopup(isFixturePopupVisible)),
        triggerMixFetchData: () => dispatch(triggerMixFetchData()),
        triggerLiveScoreFetchData: () => dispatch(triggerLiveScoreFetchData()),
        setTeamLockToastCookie: (name) => dispatch(setTeamLockToastCookie(name)),
        setTotalScore: (score) => dispatch(setTotalScore(score)),
        fetchPlayerRecomendation: () => dispatch(fetchPlayerRecomendation()),
        setPlayerRecomendationFirstTimeFalse: () => dispatch(setPlayerRecomendationFirstTimeFalse()),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        showHidePlayerRecomendationPopUpMob: (bool) => dispatch(showHidePlayerRecomendationPopUpMob(bool))
    };
};
const mapStateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        budget: state.formationData.teamData.budget,
        playerCount: state.formationData.teamData.playerCount,
        teamError: state.formationData.teamError,
        commonError: state.formationData.commonError,
        mobileFilterOpen: state.formationData.mobileFilterOpen,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        teamData: state.formationData.teamData,
        manageTeamRawData: state.formationData.manageTeamRawData,
        fixtures: state.formationData.fixtures,
        userPlayedMatchDays: state.formationData.userPlayedMatchDays,
        isPlayerCardVisible: state.formationData.isPlayerCardVisible,
        playerCardDetails: state.formationData.playerCardDetails,
        manageTeamMode: state.formationData.manageTeamMode,
        defaultFormation: state.formationData.defaultFormation,
        savedSubstitutionData: state.formationData.savedSubstitutionData,
        savedCaptainData: state.formationData.savedCaptainData,
        popupState: state.formationData.popupState,
        isFixturePopupVisible: state.formationData.isFixturePopupVisible,
        boosterPopupState: state.formationData.boosterPopupState,
        mixResponse: state.formationData.mixResponse,
        liveScore: state.formationData.liveScore.response,
        getTeam: state.formationData.getTeam,
        callPlayerRecomendation: state.formationData.playerRecomendation,
        showPlayerRecomendationPopUp: state.formationData.showPlayerRecomendationPopUp,
        showPlayerrecomendationPopupMobile: state.formationData.showPlayerrecomendationPopupMobile,
        overview: state.formationData.overview,
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageTeam));


// WEBPACK FOOTER //
// ./src/components/manage-team/manage-team.js